import { studentLogout } from "@/api/studentAuth";

export default function StudentHeader() {
  const logout = async () => {
    if (window.confirm("هل أنت متأكد من تسجيل الخروج؟")) {
      await studentLogout();
      window.location.href = "/student-login";
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.leftSection}>
          <div style={styles.logoContainer}>
            <div style={styles.logo}>👨‍🎓</div>
            <h1 style={styles.title}>لوحة تحكم الطالب</h1>
          </div>
        </div>

        <div style={styles.rightSection}>
          <div style={styles.userMenu}>
            <div style={styles.userInfo}>
              <span style={styles.userName}>الطالب أحمد</span>
              <span style={styles.userStatus}>نشط الآن</span>
            </div>
            <div style={styles.userAvatar}>
              <span style={styles.avatarText}>أ</span>
            </div>
          </div>

          <button onClick={logout} style={styles.logoutButton}>
            <span style={styles.logoutIcon}>🚪</span>
            <span>تسجيل الخروج</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: '70px',
    background: 'linear-gradient(90deg, #ffffff 0%, #f8f9fa 100%)',
    borderBottom: '1px solid #e0e0e0',
    padding: '0 25px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    direction: 'rtl',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logo: {
    fontSize: '1.8rem',
    background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
    width: '45px',
    height: '45px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    boxShadow: '0 5px 15px rgba(76, 175, 80, 0.2)',
  },
  title: {
    margin: 0,
    fontSize: '1.3rem',
    fontWeight: '700',
    color: '#333',
    background: 'linear-gradient(to right, #4CAF50, #2E7D32)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  userMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 15px',
    background: '#f8f9fa',
    borderRadius: '25px',
    border: '1px solid #e8e8e8',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  userName: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#333',
    marginBottom: '2px',
  },
  userStatus: {
    fontSize: '0.75rem',
    color: '#4CAF50',
    fontWeight: '500',
  },
  userAvatar: {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'white',
    boxShadow: '0 3px 10px rgba(33, 150, 243, 0.2)',
  },
  avatarText: {
    color: 'white',
  },
  logoutButton: {
    padding: '10px 20px',
    background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '0.9rem',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
  },
  logoutIcon: {
    fontSize: '1.1rem',
  },
};

// إضافة تأثيرات Hover
if (typeof window !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    .user-menu-hover:hover {
      background: #f0f0f0;
      transform: translateY(-1px);
    }
    
    .user-avatar-hover:hover {
      transform: scale(1.05);
    }
    
    .logout-btn-hover:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(244, 67, 54, 0.3);
    }
    
    .logout-btn-hover:active {
      transform: translateY(0);
    }
    
    .logo-hover:hover {
      transform: rotate(5deg);
    }
    
    @media (max-width: 768px) {
      .container-responsive {
        height: 60px !important;
        padding: 0 15px !important;
      }
      
      .logo-responsive {
        width: 38px !important;
        height: 38px !important;
        font-size: 1.5rem !important;
      }
      
      .title-responsive {
        font-size: 1.1rem !important;
      }
      
      .user-menu-responsive {
        padding: 6px 10px !important;
      }
      
      .user-info-responsive {
        display: none !important;
      }
      
      .user-avatar-responsive {
        width: 34px !important;
        height: 34px !important;
      }
      
      .logout-btn-responsive {
        padding: 8px 12px !important;
        font-size: 0.85rem !important;
      }
      
      .logout-icon-responsive {
        font-size: 1rem !important;
      }
    }
    
    @media (max-width: 480px) {
      .title-responsive {
        display: none !important;
      }
      
      .logout-btn-text-responsive {
        display: none !important;
      }
      
      .logout-btn-responsive {
        width: 40px !important;
        height: 40px !important;
        padding: 0 !important;
        border-radius: 50% !important;
        justify-content: center !important;
      }
    }
  `;
  document.head.appendChild(style);

  // إضافة classes للعناصر
  setTimeout(() => {
    const elements = [
      { selector: '[style*="userMenu"]', className: 'user-menu-hover' },
      { selector: '[style*="userAvatar"]', className: 'user-avatar-hover' },
      { selector: '[style*="logoutButton"]', className: 'logout-btn-hover' },
      { selector: '[style*="logo"]', className: 'logo-hover' },
    ];

    elements.forEach(({ selector, className }) => {
      const element = document.querySelector(selector);
      if (element) {
        element.className = (element.className || '') + ' ' + className;
      }
    });

    // إضافة responsive classes للجوال
    if (window.innerWidth <= 768) {
      const responsiveElements = [
        { selector: '[style*="container"]', className: 'container-responsive' },
        { selector: '[style*="logo"]', className: 'logo-responsive' },
        { selector: '[style*="title"]', className: 'title-responsive' },
        { selector: '[style*="userMenu"]', className: 'user-menu-responsive' },
        { selector: '[style*="userInfo"]', className: 'user-info-responsive' },
        { selector: '[style*="userAvatar"]', className: 'user-avatar-responsive' },
        { selector: '[style*="logoutButton"]', className: 'logout-btn-responsive' },
        { selector: '[style*="logoutIcon"]', className: 'logout-icon-responsive' },
      ];

      responsiveElements.forEach(({ selector, className }) => {
        const element = document.querySelector(selector);
        if (element) {
          element.className = (element.className || '') + ' ' + className;
        }
      });
    }

    // إضافة responsive classes للهواتف
    if (window.innerWidth <= 480) {
      const logoutButton = document.querySelector('[style*="logoutButton"]');
      if (logoutButton) {
        logoutButton.className = (logoutButton.className || '') + ' logout-btn-text-responsive';
      }
    }
  }, 100);
}